<template>
  <v-dialog v-model="dialog" persistent width="400" @keydown.esc="cancel">
    <v-card v-if="role" class="p-8 text-center">
      <v-form @submit.prevent="ok">
        <h3 class="text-3xl">Are you sure you want to remove this role?</h3>
        <v-chip class="bg-vgsoftblue my-4 truncate">
          {{ role.value }}
        </v-chip>
        <p class="text-vgstone">
          Removing this role will also remove all of the VA candidates currently
          selected. It will also remove the role from the search filter.
        </p>
        <div class="flex justify-center p-4">
          <vg-btn vg-type="secondary" class="mr-4" @click="cancel"
            >Cancel</vg-btn
          >
          <vg-btn type="submit">Yes</vg-btn>
        </div>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapStores } from 'pinia';
import { useCheckoutStore } from '@/stores/checkout';

export default {
  name: 'DeleteRoleDialog',
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    role: null,
  }),
  computed: {
    ...mapStores(useCheckoutStore),
  },
  methods: {
    open(role) {
      this.role = role;
      this.dialog = true;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    async ok() {
      await this.removeRole();
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
    async removeRole() {
      this.checkoutStore.toggleSelectedRoles({
        ...this.role,
        id: this.role.id ?? this.role.role_id,
      });
      await this.checkoutStore.updateMatchingCriteria({
        ...this.checkoutStore.matchingCriteria,
        cart: this.checkoutStore.matchingCriteria.cart.filter(
          (cartItem) =>
            parseInt(cartItem.role_id) !==
            parseInt(this.role.id ?? this.role.role_id)
        ),
      });

      if (
        this.checkoutStore.matchingCriteria.cart.length === 0 &&
        this.$route.fullPath !== '/search?step=roles'
      ) {
        return this.$router.push(`/search?step=roles`);
      }
    },
  },
};
</script>
